import { render, staticRenderFns } from "./AnswerComponent.vue?vue&type=template&id=17615876&scoped=true"
import script from "./AnswerComponent.vue?vue&type=script&lang=js"
export * from "./AnswerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17615876",
  null
  
)

export default component.exports